import type { ApiClient } from '@/api/client'

import type { ProviderSummary } from '../providers'
import { integrationLabel } from './status'

/** The Integrations list's badge for Google Analytics. */
export async function ga4Summary(client: ApiClient): Promise<ProviderSummary> {
  return integrationLabel(await client.ga4Integration())
}
